export const AllSubventionsDeadlines = [
    { value: 0, label: 'Disponibilizados' },
    { value: 1, label: 'Válida por 24 meses ou até a utilização total dos recursos' },
    { value: 2, label: 'Recorrente' }
]